module.exports = __webpack_public_path__ + "media/wrong.5c4173db.wav";